import React, { useEffect, useRef, useState } from "react";
import "./aboutChannel.css";
import moment from "moment";
import axios from "../../../../axios";

const AboutChannel = ({
  setEditCommunityDetails,
  setViewFirstInProgress,
  editCommunityDetails,
  community,
}) => {
  const [communityDetails, setCommunityDetails] = useState({
    editingMode: false,
    description: "",
  });
  useEffect(() => {
    setCommunityDetails({
      ...communityDetails,
      description: community?.short_description
        ? community?.short_description
        : "",
    });
  }, [community?.short_description]);

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const { editingMode, description } = communityDetails;
  const { operationDone } = editCommunityDetails;

  const handleSubmit = async () => {
    setViewFirstInProgress(true);
    try {
      let res = await axios.put(`/api/v1/community/update/${community?.id}`, {
        user_id: teacher_id,
        short_description: description,
      });

      res &&
        setCommunityDetails({
          ...communityDetails,
          operationDone: !operationDone,
          editingMode: !editingMode,
        });
      setEditCommunityDetails({
        ...editCommunityDetails,
        operationDone: !operationDone,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return community ? (
    <div className="col-md-12 p-0">
      <div className="card shadow-sm border-0 p-3 mb-4">
        <div className=" d-flex align-items-center justify-content-between">
          <h5 className="mb-0 text-[16px] badge shadow-sm">Description</h5>
        </div>
        <p className="my-3 descriptiont_text text-justify">
          {community?.short_description}
        </p>
      </div>
      <div className="card shadow-sm border-0 p-3 ">
        <div className="d-flex align-items-center">
          <h6
            className="badge shadow-sm text-center  mb-3"
            style={{ width: "80px" }}
          >
            Details
          </h6>
        </div>
        <div
          className="d-flex flex-row  align-items-center"
          style={{ gap: "10rem" }}
        >
          <div className="">
            <strong className="text-muted d-block">Created On</strong>
            <span>{moment(community?.created_at).format("Do MMM YYYY")}</span>
          </div>
          <div className="">
            <strong className="text-muted d-block">Last Modified</strong>
            <span>{moment(community?.updated_at).format("Do MMM YYYY")}</span>
          </div>
          <div>
            <strong className="text-muted d-block">Created By</strong>
            <span>{community?.user_id?.name}</span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default AboutChannel;
